__webpack_require__.p = "https://www.vietnamworks.com/v2/_next/";